import { useEffect, useState } from 'react'

import goUp from '../../assets/common/go_up.svg'

const GoUp = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > 200)
    }

    window.addEventListener('scroll', onScroll)
    return () => window.addEventListener('scroll', onScroll)
  }, [])

  if (!isVisible) return null

  return (
    <button
      className="cursor-pointer flex animate-fadeIn mb-[5px] hover:scale-105"
      id="go-up"
      aria-label="scroll up">
      <img
        className="pointer-events-none w-[50px] h-[51.66px]"
        src={goUp}
        alt="scroll up"
      />
    </button>
  )
}

export default GoUp
